import { DayOfRaceRegion, DayOfRaceResponse } from '@cds/betting-offer/domain-specific/horse-racing';
import { WinGameFixture, WinGameFixturePreview, toRacingFixturePreview } from '@frontend/sports/racing/feature/models';

export interface DayOfRaceModel {
    fixtures: WinGameFixturePreview[];
    regions: { [pos: number]: DayOfRaceRegion[] };
}

export interface TodayRaceModel<TRacePredictor extends WinGameFixture = WinGameFixture> extends DayOfRaceModel {
    nextFixtures: TRacePredictor[];
}

export function toDayOfRaceModel(dto: DayOfRaceResponse): DayOfRaceModel {
    return {
        fixtures: dto.fixtures.map(toRacingFixturePreview),
        regions: dto.regions,
    };
}
